export default class DataSource {
    constructor(data) {
        this.url = window.location.origin;
        this.data = [];
        this.columns = [];

        if (data) {
            this.data = data;
            this.columns = Object.keys(data[0]);
        }
    }

    async init(params) {
        const fetchData = await fetch('/wp-json/skolord-api/v1/fetch/'+params.id)
            .then(res => res.json());

        let data = Object.values(fetchData); // Convert to array instead of object

        this.columns = Object.keys(fetchData[0]);

        if (params.offset && params.limit) {
            data = fetchData.slice(params.offset, params.offset+params.limit);
        } else if (params.offset) {
            data = fetchData.slice(params.offset);
        }

        return new DataSource(data);
    }

    getNumberOfColumns() {
        return Object.keys(this.data[0]).length;
    }

    getNumberOfRows() {
        return this.data.length;
    }

    getDataTable() {
        return this.data;
    }

    getColumnId(i) {
        return Object.keys(this.data[0])[i];
    }

    getValue(row, column) {
        return this.data[row][this.columns[column]];
    }
}